{
  "phase.roleReveal": "Regardez votre carte et mémorisez-la.",
  "phase.night": "La nuit tombe sur le village. Tout le monde ferme les yeux.",
  "wake.werewolf": "Loups-garous, réveillez-vous et regardez-vous. Si vous êtes seul, vous pouvez regarder une carte du centre.",
  "sleep.werewolf": "Loups-garous, fermez les yeux.",
  "wake.minion": "Sbire, réveille-toi et repère les loups-garous.",
  "sleep.minion": "Sbire, ferme les yeux.",
  "wake.mason": "Francs-maçons, réveillez-vous et regardez-vous.",
  "sleep.mason": "Francs-maçons, fermez les yeux.",
  "wake.seer": "Voyante, réveille-toi. Tu peux regarder la carte d'un autre joueur, ou deux cartes du centre.",
  "sleep.seer": "Voyante, ferme les yeux.",
  "wake.robber": "Voleur, réveille-toi. Tu peux échanger ta carte avec celle d'un autre joueur, puis regarder ta nouvelle carte.",
  "sleep.robber": "Voleur, ferme les yeux.",
  "wake.troublemaker": "Noiseuse, réveille-toi. Tu peux échanger les cartes de deux autres joueurs, sans les regarder.",
  "sleep.troublemaker": "Noiseuse, ferme les yeux.",
  "wake.drunk": "Soûlard, réveille-toi. Échange ta carte avec une carte du centre, sans la regarder.",
  "sleep.drunk": "Soûlard, ferme les yeux.",
  "wake.insomniac": "Insomniaque, réveille-toi et regarde ta carte.",
  "sleep.insomniac": "Insomniaque, ferme les yeux.",
  "phase.stopped": "La manche est interrompue. Ouvrez les yeux, tout le monde revient au salon.",
  "phase.day": "Le jour se lève. Tout le monde ouvre les yeux.",
  "phase.vote": "Le temps est écoulé. Le vote commence : désignez un joueur.",
  "outcome.village": "Le village l'emporte !",
  "outcome.werewolf": "Les loups-garous l'emportent !",
  "outcome.tanner": "Le tanneur l'emporte, seul : il voulait mourir, vous l'avez tué.",
  "outcome.tanner_village": "Le tanneur et le village l'emportent ensemble !",
  "outcome.nobody": "Personne ne l'emporte. Un innocent est mort pour rien.",
  "reveal.5": "Vous avez cinq secondes.",
  "reveal.10": "Vous avez dix secondes.",
  "reveal.15": "Vous avez quinze secondes.",
  "reveal.20": "Vous avez vingt secondes.",
  "reveal.25": "Vous avez vingt-cinq secondes.",
  "reveal.30": "Vous avez trente secondes.",
  "reveal.35": "Vous avez trente-cinq secondes.",
  "reveal.40": "Vous avez quarante secondes.",
  "reveal.45": "Vous avez quarante-cinq secondes.",
  "reveal.50": "Vous avez cinquante secondes.",
  "reveal.55": "Vous avez cinquante-cinq secondes.",
  "reveal.60": "Vous avez une minute.",
  "reveal.70": "Vous avez une minute et dix secondes.",
  "reveal.80": "Vous avez une minute vingt.",
  "reveal.90": "Vous avez une minute trente.",
  "reveal.100": "Vous avez une minute quarante.",
  "reveal.110": "Vous avez une minute cinquante.",
  "reveal.120": "Vous avez deux minutes.",
  "debate.60": "Vous avez une minute pour débattre.",
  "debate.90": "Vous avez une minute trente pour débattre.",
  "debate.120": "Vous avez deux minutes pour débattre.",
  "debate.150": "Vous avez deux minutes trente pour débattre.",
  "debate.180": "Vous avez trois minutes pour débattre.",
  "debate.210": "Vous avez trois minutes trente pour débattre.",
  "debate.240": "Vous avez quatre minutes pour débattre.",
  "debate.270": "Vous avez quatre minutes trente pour débattre.",
  "debate.300": "Vous avez cinq minutes pour débattre.",
  "debate.330": "Vous avez cinq minutes trente pour débattre.",
  "debate.360": "Vous avez six minutes pour débattre.",
  "debate.390": "Vous avez six minutes trente pour débattre.",
  "debate.420": "Vous avez sept minutes pour débattre.",
  "debate.450": "Vous avez sept minutes trente pour débattre.",
  "debate.480": "Vous avez huit minutes pour débattre.",
  "debate.510": "Vous avez huit minutes trente pour débattre.",
  "debate.540": "Vous avez neuf minutes pour débattre.",
  "debate.570": "Vous avez neuf minutes trente pour débattre.",
  "debate.600": "Vous avez dix minutes pour débattre.",
  "debate.630": "Vous avez dix minutes trente pour débattre.",
  "debate.660": "Vous avez onze minutes pour débattre.",
  "debate.690": "Vous avez onze minutes trente pour débattre.",
  "debate.720": "Vous avez douze minutes pour débattre.",
  "debate.750": "Vous avez douze minutes trente pour débattre.",
  "debate.780": "Vous avez treize minutes pour débattre.",
  "debate.810": "Vous avez treize minutes trente pour débattre.",
  "debate.840": "Vous avez quatorze minutes pour débattre.",
  "debate.870": "Vous avez quatorze minutes trente pour débattre.",
  "debate.900": "Vous avez quinze minutes pour débattre.",
  "debate.930": "Vous avez quinze minutes trente pour débattre.",
  "debate.960": "Vous avez seize minutes pour débattre.",
  "debate.990": "Vous avez seize minutes trente pour débattre.",
  "debate.1020": "Vous avez dix-sept minutes pour débattre.",
  "debate.1050": "Vous avez dix-sept minutes trente pour débattre.",
  "debate.1080": "Vous avez dix-huit minutes pour débattre.",
  "debate.1110": "Vous avez dix-huit minutes trente pour débattre.",
  "debate.1140": "Vous avez dix-neuf minutes pour débattre.",
  "debate.1170": "Vous avez dix-neuf minutes trente pour débattre.",
  "debate.1200": "Vous avez vingt minutes pour débattre."
}
